module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_4.8b342d78.png";